import type { FormTarget, IOrderAttributeOutput, OrderAttribute } from "@jti/magento";

export interface GroupedOrderAttributesByPlacement {
  updatedShippingAttributes: IOrderAttributeOutput[];
  updatedBillingAttributes: IOrderAttributeOutput[];
}

export const groupOrderAttributesByAddressPlacement = (
  orderAttributesValues: IOrderAttributeOutput[],
  orderAttributesConfig: OrderAttribute[]
): GroupedOrderAttributesByPlacement => {
  const orderAttributesMap = orderAttributesConfig.reduce(
    (map, attribute) => {
      map[attribute.code] = attribute.placement;
      return map;
    },
    {} as Record<string, FormTarget>
  );

  const updatedShippingAttributes: IOrderAttributeOutput[] = [];
  const updatedBillingAttributes: IOrderAttributeOutput[] = [];

  for (const attribute of orderAttributesValues) {
    const placement = orderAttributesMap[attribute.attribute_code];
    if (placement === "shippingAddress_before" || placement === "shippingAddress_after") {
      updatedShippingAttributes.push(attribute);
    } else if (placement === "billingaddress_before" || placement === "billingaddress_after") {
      updatedBillingAttributes.push(attribute);
    }
  }

  return {
    updatedShippingAttributes,
    updatedBillingAttributes,
  };
};
